import { useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { setClerkToken, clearClerkToken } from '../services/api/clerkTokenManager';

/**
 * ClerkTokenSync Component
 * 
 * Syncs the Clerk authentication token from React context to the token manager
 * so it can be used by axios interceptors.
 * 
 * This component should be placed inside ClerkProvider but outside any routes.
 */
export function ClerkTokenSync() {
  const { getToken, isSignedIn } = useAuth();

  useEffect(() => {
    let mounted = true;

    async function syncToken() {
      if (!isSignedIn) {
        clearClerkToken();
        return;
      }

      try {
        const token = await getToken();
        if (mounted && token) {
          setClerkToken(token);
        }
      } catch (error) {
        console.error('[ClerkTokenSync] Error getting token:', error);
      }
    }

    syncToken();

    // Refresh token periodically (every 30 seconds)
    const interval = setInterval(syncToken, 30000);

    return () => {
      mounted = false;
      clearInterval(interval);
    };
  }, [getToken, isSignedIn]);

  return null; // This component doesn't render anything
}
